import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { MatChipSelectionChange } from '@angular/material/chips';
import { BaseViewComponent } from '@sb/library/base';
import { ChipButtonTabsItemComponent } from './item/chip-button-tabs-item.component';

@Component({
    selector: 'lib-chip-button-tabs',
    templateUrl: './chip-button-tabs.component.html',
    styleUrls: ['./chip-button-tabs.component.scss']
})
export class ChipButtonTabsComponent<T> extends BaseViewComponent {

    private _selected!: T;

    @Input() loading: boolean = false;
    @Input() set currentSelection(value: T) {
        this._selected = value;
    }
    @Output() selectionChange: EventEmitter<T> = new EventEmitter();

    @ContentChildren(ChipButtonTabsItemComponent) chipOptions!: QueryList<ChipButtonTabsItemComponent<T>>;

    ngAfterContentInit() {
        if (!this._selected && this.chipOptions.length) {
            this._selected = this.chipOptions.first.value;
        }
    }

    SelectionChange(event: MatChipSelectionChange) {
        if (event.selected) {
            this._selected = event.source.value;
            this.selectionChange.emit(event.source.value);
        }
    }

    get selected(): T {
        return this._selected;
    }
}
